import { useTranslation } from "react-i18next";
import CalendarSync from "../../../../components/candidate-calendar/CalendarSync";

export default function Synchronizers() {
  const LocalBasePath = "page.calendar";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <div className="w-full flex flex-col">
      <div>
        <h1 className=" text-lg leading-6 font-medium text-gray-900 my-6">
          {t("calendarSyncs")}
        </h1>
      </div>
      <CalendarSync />
    </div>
  );
}
